import { ExplanationRevisionStatusV2 } from 'src/lib/gql-client'

import { isAgreementCompleted } from './isAgreementCompleted'

/** 一度でも「同意完了」しているステータスか否かを判定（for v2） */
export const hasBeenAgreementCompleted = (
  status: ExplanationRevisionStatusV2,
) => {
  return isAgreementCompleted(status) || status === 'Withdrawn'
}
